
import React, { useEffect, useState } from 'react';
import styles from '../components/UpcomingEvents/UpcomingEvents.module.scss';
import Card from "react-bootstrap/Card";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Slider from "react-slick";
import { useRouter } from 'next/router';
import _debounce from 'lodash/debounce'
import fetchUtil from '../utils/fetchUtil';

interface Props {
  title: string
}

const FeaturedPartnerWebinars: React.FC<Props> = ({ title }) => {
  const [delegateWebinars, setDelegateWebinars] = useState<any>([])
  const [kcExpertWebinars, setKcExpertWebinars] = useState<any>([])
  const [tabValue, setTabValue] = useState<number>(1)
  const router = useRouter()

  useEffect(() => {
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/partner-webinars?webinarType=webinar_by_university_delegate&_sort=startDate:ASC&_start=0&_limit=3`, 'GET', {}, '', false)
      .then((res: any) => {
        setDelegateWebinars(res)
      })
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/partner-webinars?webinarType=webinar_by_kc_expert&_sort=startDate:ASC&_start=0&_limit=3`, 'GET', {}, '', false)
      .then((res: any) => {
        setKcExpertWebinars(res)
      })
  }, [])

  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };
  const respectiveWebinars = tabValue === 1 ? delegateWebinars : kcExpertWebinars
  return (
    <>
      <Container id='featured-partnerwebinars'>
        <div className={styles.theEventweek}>
          <h2 className={styles.mainTitle}>{title}</h2>
        </div>
        <div >
          <ul className={`${styles.eventTabs} nav nav-tabs`} style={{ marginBottom: '50px' }}>
            <li className="nav-item" >
              <button
                onClick={() => setTabValue(1)}
                type="button"
                className={`nav-link ${tabValue === 1 ? 'active' : ''}`}>
                Webinars by University
              </button>
            </li>
            <li className="nav-item" >
              <button
                onClick={() => setTabValue(2)}
                type="button"
                className={`nav-link ${tabValue === 2 ? 'active' : ''}`}>
                Webinars by KC
              </button>
            </li>
          </ul>
        </div>
        <div className="d-none d-sm-block">
          <div id='the-eventweek' className={styles.theEventweek}>
            <Row>
              {respectiveWebinars?.length > 0
                ? respectiveWebinars.map((event: any) => {
                  return (
                    <Col xs={12} md={4} key={event.id}>
                      <Card className={styles.cardCust} style={{ height: "350px" }}>
                        <Card.Img variant="top" src={event.imageUrl} alt={event.imageAltTag} />
                        <Card.Body className={styles.cardBody}>
                          <Card.Text className={styles.textDate} >{event.date} · {event.time}</Card.Text>
                          <Card.Title className={styles.subTitle}>{event.name}</Card.Title>
                          <Button size="lg" className={styles.btEduExpo}
                            onClick={() => router.push(event.registerUrl)}>
                            Register Now
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  )
                })
                : 'No Webinars'
              }
            </Row>
          </div>
        </div>
        <div id='respectiveWebinars' className="d-block d-sm-none">
          {respectiveWebinars.length > 0
            ? <div className={styles.theEventweek}>
              <Slider {...settings} className={styles.slider}>
                {
                  respectiveWebinars.map((event: any) => {
                    return (
                      <div key={event.id}>
                        <Row>
                          <Col xs={12} md={4}>
                            <Card className={styles.cardCust}>
                              <Card.Img variant="top" src={event.imageUrl} alt={event.imageAltTag} />
                              <Card.Body className={styles.cardBody}>
                                <Card.Text className={styles.textDate} >{event.date} · {event.time}</Card.Text>
                                <Card.Title className={styles.subTitle}>{event.name}</Card.Title>
                                <Button size="lg" className={styles.btEduExpo}
                                  onClick={() => router.push(event.registerUrl)}>
                                  Register Now
                                </Button>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
            : 'No Webinars'}
        </div>
        <div className="text-center mt-3 mb-5">
          <a href={`${tabValue === 1 ? '/partners/webinar-by-university-delegates' : '/partners/webinar-by-kc-admission-experts'}`} className={styles.viewMore}>View More</a>
        </div>
      </Container >
    </>
  )
}

export default FeaturedPartnerWebinars;
